import { gql } from 'graphql-request';

import type { CurrencyISO } from '@/constants/currencies';
import type { CountryISO } from '@/constants/countries';

interface PortfolioAnalysis {
  value: number;
  marketCountryISO: CountryISO;
  roa: number | null;
  roce: number | null;
  roe: number | null;
  fairValue: number | null;
  debtToEquityRatio: number | null;
  payoutRatio: number | null;
  pe: number | null;
  ps: number | null;
  pb: number | null;
  peg: number | null;
  netIncomeGrowthAnnualPast5y: number | null;
  netIncomeGrowthAnnual: number | null;
  revenueGrowthAnnualPast5y: number | null;
  revenueGrowthAnnual: number | null;
  epsGrowthAnnualPast5y: number | null;
  epsGrowthAnnual: number | null;
  estimatedDividendYield: number;
  dividendPaymentsGrowthAnnual: number | null;
}

type GeoDiversificationByRegion = Record<
  string,
  {
    companies: [{ symbol: string; weight: number }];
    weight: number;
  }
>;

type DiversificationTree = {
  type: string;
  weight: number;
  name?: string;
  symbol?: string;
  sectors?: DiversificationTree[];
  primaryIndustries?: DiversificationTree[];
  holdings?: DiversificationTree[];
};

export interface PortfolioAnalysisFragmentType {
  id: string;
  currencyISO: CurrencyISO;
  analysis: PortfolioAnalysis;
  diversification: DiversificationTree;
  geoDiversificationByRegion: GeoDiversificationByRegion;
}

export const PORTFOLIO_ANALYSIS_FRAGMENT = gql`
  fragment portfolioAnalysisFields on Portfolio {
    id
    currencyISO
    geoDiversificationByRegion
    diversification
    analysis {
      roa
      roce
      roe
      value
      fairValue
      debtToEquityRatio
      payoutRatio
      marketCountryISO
      pe
      ps
      pb
      peg
      netIncomeGrowthAnnualPast5y
      netIncomeGrowthAnnual
      revenueGrowthAnnualPast5y
      revenueGrowthAnnual
      epsGrowthAnnualPast5y
      epsGrowthAnnual
      estimatedDividendYield
      dividendPaymentsGrowthAnnual
    }
  }
`;
